import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef } from 'react';
import { useCashDialog } from './useCashDialog';
export function CashButton({ children, primary, danger, ...props }) {
    return _jsx("button", { type: "button", ...props, className: `cash-button ${primary ? 'cash-primary' : ''} ${danger ? 'cash-danger-button' : ''} ${props.className || ''}`, children: children });
}
export function CashNotice({ children, tone = 'info' }) {
    return _jsx("div", { className: `cash-notice cash-notice-${tone}`, role: tone === 'danger' ? 'alert' : 'status', children: children });
}
export function CashField({ label, children, help, error }) {
    return _jsxs("label", { className: "cash-field", children: [_jsx("span", { children: label }), children, help && _jsx("small", { children: help }), error && _jsx("small", { className: "cash-field-error", role: "alert", children: error })] });
}
export function CashDialog({ title, children, onClose, closeLabel, initialFocusSelector, initialFocusReady = true }) {
    const ref = useRef(null);
    const titleId = useId();
    useCashDialog(ref);
    const initialFocused = useRef(false);
    useEffect(() => () => { initialFocused.current = false; }, []);
    useEffect(() => {
        if (!initialFocusSelector || !initialFocusReady || initialFocused.current)
            return;
        const field = ref.current?.querySelector(initialFocusSelector);
        field?.focus();
        if (field && document.activeElement === field)
            initialFocused.current = true;
    }, [initialFocusSelector, initialFocusReady]);
    return _jsxs("dialog", { className: "cash-dialog", ref: ref, "aria-labelledby": titleId, onCancel: event => { event.preventDefault(); onClose(); }, children: [_jsxs("div", { className: "cash-dialog-heading", children: [_jsx("h2", { id: titleId, children: title }), _jsx(CashButton, { onClick: onClose, "aria-label": closeLabel, children: "\u00D7" })] }), _jsx("div", { className: "cash-dialog-body", children: children })] });
}
export function CashFacts({ rows }) {
    return _jsx("dl", { className: "cash-facts", children: rows.map(([label, value], index) => _jsxs("div", { children: [_jsx("dt", { children: label }), _jsx("dd", { children: value })] }, `${label}-${index}`)) });
}
